const modals = {
  id: null,
  deadlineDate: null,
  orderMode: null,
  placeOrderTime: null,
  placeOrderUserName: null,
  productList: [],
  purchaseOrderNumber: null,
  remark: null,
  shopCode: null,
  shopName: null,
  showCustomerInfo: false,
  urgencyFlag: null,
  showVoucherBtns: false, // 是否显示送达确认按钮
  // 凭证信息
  voucherInfoList: [],
  canSendVoucher: true, // 是否显示送达凭证
  sourceType: null, // 来源类型
  orderStatus: null, // 订单状态
  signatureItemList: [], // 验收签字
};
export default modals;
